import React from 'react';
import './confirmation-header.scss';

export function ConfirmationHeader() {
  return (
    <div className="confirmation-header header-wrapper pt-3">
      <h1 className="header text-center size-30 fw-bold text-white my-0 mx-auto px-1_5 w-100">
        Your real rates have been sent to the dealer
      </h1>
    </div>
  );
}
